module.exports = __webpack_public_path__ + "static/simufact0B-0a900419739b12ebbad87f9d3bc5dea5.jpg";